import type { FlowAlertSettings } from './flowAlertSettingsStore';
import { summarizeFlowAlertSettings } from './flowAlertSettingsStore';

/** English / Arabic phrases that mean "show my alert settings". */
const SHOW_SETTINGS_PATTERNS = [
  /^show\s+(my\s+)?(current\s+)?alert\s+settings?\.?$/i,
  /^what\s+are\s+my\s+alert\s+settings?\.?$/i,
  /^list\s+my\s+alert\s+rules?\.?$/i,
  /^my\s+alert\s+settings?\.?$/i,
  /^current\s+alert\s+config(uration)?\.?$/i,
  /^(اعرض|أعرض|ورّني|ورني)\s+(إعدادات|اعدادات)\s+(التنبيه|التنبيهات|الإشعار|الاشعارات)/,
  /^(ما هي|ما)\s+إعدادات\s+التنبيه/,
  /^إعدادات\s+التنبيهات\s+(الحالية|الخاصة بي)?/,
  /^عرض\s+قواعد\s+التنبيه/,
  /^قواعد\s+التنبيه\s+الحالية/,
];

export function isShowAlertSettingsQuery(message: string): boolean {
  const t = (message || '').trim();
  if (!t) return false;
  return SHOW_SETTINGS_PATTERNS.some((re) => re.test(t));
}

export function formatAlertSettingsForChat(
  settings: FlowAlertSettings,
  language: 'en' | 'ar',
): string {
  const ar = language === 'ar';
  const lines: string[] = [];

  lines.push(ar ? '📋 إعدادات التنبيه الحالية' : '📋 Your current alert settings');
  lines.push('');
  lines.push(summarizeFlowAlertSettings(settings, language));
  lines.push('');

  const rules = (settings.rules || []).filter((r) => r.enabled);
  if (rules.length) {
    lines.push(ar ? 'قواعد مفعّلة:' : 'Active rules:');
    rules.forEach((r, i) => {
      const src = r.source ? ` [${r.source}]` : '';
      lines.push(`  ${i + 1}. ${r.field} ${r.operator} ${r.value}${src}`);
    });
  } else {
    lines.push(
      ar
        ? 'لا توجد قواعد مخصصة — يُستخدم حد التدفق الكبير إن كان مفعّلاً.'
        : 'No custom rules — big-flow floor applies if enabled.',
    );
  }

  const custom = settings.custom_fields || [];
  if (custom.length) {
    lines.push('');
    lines.push(ar ? 'معاملات مخصصة:' : 'Custom parameters:');
    custom.forEach((c) => {
      lines.push(
        `  • ${c.label || c.id}${c.expression ? `: ${c.expression}` : ''}`,
      );
    });
  }

  const watch = settings.watchlist_symbols || [];
  if (watch.length) {
    lines.push('');
    lines.push(
      ar
        ? `قائمة مراقبة: ${watch.join(', ')}`
        : `Watchlist: ${watch.join(', ')}`,
    );
  }

  lines.push('');
  lines.push(
    ar
      ? 'لتغيير الإعدادات، صِف ما تريد (مثال: نبّهني على SPX عند علاوة فوق 500 ألف على الشراء).'
      : 'To change settings, describe what you want (e.g. alert me on SPX when premium over $500k on buys).',
  );

  return lines.join('\n');
}
